import { createFileRoute } from '@tanstack/react-router';

import VStack from '@/components/Layout/VStack';
import { Text } from '@/components/Typography/Text';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { useTranslation } from '@/lib/i18n';

export const Route = createFileRoute('/_stacktrace/product-planning-core')({
  component: ProductPlanningCorePage,
});

function ProductPlanningCorePage() {
  const { t } = useTranslation();
  const title = t('component.sidebar.ppForceProductPlanningCore');
  useDocumentTitle(title);

  return (
    <VStack className="flex-1 items-center justify-center gap-2 px-12 py-5">
      <Text variant="h2">{title}</Text>
      <Text variant="p" className="text-neutral-muted-on-fill">
        {t('common.placeholder.comingSoon')}
      </Text>
    </VStack>
  );
}
